import React from 'react';
import { X } from 'lucide-react';
import metaApi from '../../api/meta';

const MetaPermissionRequestModal = ({ isOpen, onClose, platform = 'meta' }) => {
  if (!isOpen) return null;

  const handleRequestPermissions = () => {
    const targetPlatform = platform === 'whatsapp' ? 'whatsapp' : 'meta';
    const returnTo = `/campaign-wizard?step=1.5&platform=${targetPlatform}`;
    metaApi.startMetaOAuthWithScopes('extended', returnTo);
  };

  return (
    <div className="fixed inset-0 modal-safe-area z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-gradient-to-b from-slate-900 to-slate-800 border border-white/20 rounded-2xl shadow-2xl max-w-md w-full mx-4 overflow-hidden">
        {/* Header */}
        <div className="p-6 border-b border-white/10">
          <div className="flex items-center justify-between">
            <h2 className="text-lg font-semibold text-white">Permisos Adicionales Requeridos</h2>
            <button onClick={onClose} className="p-1 hover:bg-white/10 rounded-lg transition-colors">
              <X className="w-5 h-5 text-white/60" />
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          <p className="text-white/80 text-sm">
            Para crear campañas en Meta, necesitamos acceso adicional a:
          </p>

          <ul className="space-y-3">
            <li className="flex items-start gap-3">
              <div className="w-5 h-5 rounded-full bg-green-500/20 flex items-center justify-center flex-shrink-0 mt-0.5 border border-green-500/50">
                <span className="text-green-300 text-xs">✓</span>
              </div>
              <div>
                <div className="text-white font-medium text-sm">Páginas de Facebook</div>
                <div className="text-white/60 text-xs">Selecciona la página para publicar anuncios</div>
              </div>
            </li>

            <li className="flex items-start gap-3">
              <div className="w-5 h-5 rounded-full bg-green-500/20 flex items-center justify-center flex-shrink-0 mt-0.5 border border-green-500/50">
                <span className="text-green-300 text-xs">✓</span>
              </div>
              <div>
                <div className="text-white font-medium text-sm">Cuentas de Instagram Business</div>
                <div className="text-white/60 text-xs">Vincula tu cuenta de Instagram para campañas integradas</div>
              </div>
            </li>

            <li className="flex items-start gap-3">
              <div className="w-5 h-5 rounded-full bg-green-500/20 flex items-center justify-center flex-shrink-0 mt-0.5 border border-green-500/50">
                <span className="text-green-300 text-xs">✓</span>
              </div>
              <div>
                <div className="text-white font-medium text-sm">Números de WhatsApp Business</div>
                <div className="text-white/60 text-xs">Gestiona campañas de WhatsApp</div>
              </div>
            </li>
          </ul>

          <div className="bg-blue-500/10 border border-blue-500/30 rounded-lg p-3 mt-4">
            <p className="text-blue-300 text-xs">
              Estos permisos solo se utilizan para integrar tus activos de Meta al crear campañas.
            </p>
          </div>
        </div>

        {/* Actions */}
        <div className="p-6 border-t border-white/10 space-y-3">
          <button
            onClick={handleRequestPermissions}
            className="w-full px-4 py-2.5 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-medium rounded-lg transition-all shadow-lg hover:shadow-xl active:scale-95"
          >
            Conceder Permisos
          </button>
          <button
            onClick={onClose}
            className="w-full px-4 py-2.5 bg-white/10 hover:bg-white/15 text-white font-medium rounded-lg transition-colors border border-white/20"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};

export default MetaPermissionRequestModal;
